import * as React from 'react';
import { useSelector } from 'react-redux';
import { BreadCrumbs as BreadCrumbsComponent } from '../../components/BreadCrumbs';
import { getBreadcrumbs } from '../../selectors';
import { Responsive } from '@cian/ui-kit';

export function BreadCrumbs() {
  const breadcrumbs = useSelector(getBreadcrumbs);

  return (
    <Responsive desktop>
      <BreadCrumbsComponent breadcrumbs={breadcrumbs} />
    </Responsive>
  );
}
